import { Link } from 'react-router-dom';

import { Paragraph, Image } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

interface DevelopBannerProps {
  title: string;
  imgSrc: string;
  imgClassName: string;
  cardNumber: number;
  bannerClassName: string;
}

export const DevelopBanner = ({
  title,
  imgSrc,
  imgClassName,
  cardNumber,
  bannerClassName,
}: DevelopBannerProps) => {
  return (
    <Link
      to={`/development/${cardNumber}`}
      className={cn(
        'px-4 pt-4 pb-2 rounded-[15px] cursor-pointer overflow-hidden relative flex flex-col justify-between w-full h-[120px] bg-cognition-develop-banner',
        bannerClassName
      )}
    >
      <Paragraph className="z-10">{title}</Paragraph>
      <Image src={imgSrc} alt={`${title} banner`} className={cn('absolute', imgClassName)} />
      <span className="text-[43px] z-10 leading-[18px] font-semibold mb-4 text-white/40">
        {cardNumber}
      </span>
    </Link>
  );
};
